import axios from "axios";

const $http = axios.create({
  baseURL:
    process.env.NODE_ENV == "development" ? "/api" : (window as any).g.baseURL,
});

export default $http;
